export const StoryMentionRoutes = [
  {
    path: 'storyMention/:mode?/:content_id?',
    lazy: () => import('./storyMentionReply.page'),
  },
] as const
